/**
 * Iter Feb 2026 R54 · Route-mount telemetry.
 * Mounted once inside AppShell. Fires POST /telemetry/screen every time
 * the route changes so super-admins can see top-visited screens per
 * workspace + globally. Best-effort — never blocks the UI.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function PageTelemetry() {
  const loc = useLocation();
  const { activeWorkspaceId } = useAuth();

  useEffect(() => {
    const t = setTimeout(() => {
      api.post("/telemetry/screen", {
        workspace_id: activeWorkspaceId || null,
        path: loc.pathname,
        title: document.title || "",
      }).catch(() => {});
    }, 400);
    return () => clearTimeout(t);
  }, [loc.pathname, activeWorkspaceId]);

  return null;
}
